<template>
  <div style="overflow-x:hidden;background: #7AC7FC" :style="viewStyle">
    <div class="header-bar">
      <v-img :src="images.new_logo" class="header-logo"></v-img>
      <v-img :src="images.title" class="header-title"></v-img>
      <v-img :src="images.school" class="header-school"></v-img>
      <v-img :src="images.icon_L1" class="header-icon" style="top: 300px; left: 4%"></v-img>
      <v-img :src="images.icon_L2" class="header-icon" style="top: 600px; left: 12%"></v-img>
      <v-img :src="images.icon_L3" class="header-icon" style="top: 900px; left: 0%"></v-img>
      <v-img :src="images.icon_L4" class="header-icon" style="top: 1200px; left: 8%"></v-img>
      <v-img :src="images.icon_R1" class="header-icon" style="top: 300px; right: 4%"></v-img>
      <v-img :src="images.icon_R2" class="header-icon" style="top: 600px; right: 0%"></v-img>
      <v-img :src="images.icon_R3" class="header-icon" style="top: 900px; right: 12%"></v-img>
      <v-img :src="images.icon_R4" class="header-icon" style="top: 1200px; right: 5%"></v-img>
    </div>
    <div class="ma-0">
      <v-row class="mx-0 mt-6" style="width:100%; height:100%; align-items: center;" justify="center">
        <v-col class="col-12 col-sm-10 col-md-8" style="display: flex; justify-content: center"> 
          <div id="box2" class="px-2 py-12">
            <v-row class="ma-0" justify="center">
              <v-col class="py-0 col-11 col-sm-10 col-md-8">
                <v-row class="ma-0 DarkBlue" justify="center" style="align-items: center">
                  <div style="flex:1; height:2px; background:#000; margin:0"></div>
                  <h1 class="title-text">國高中招生報名系統</h1>
                  <div style="flex:1; height:2px; background:#000; margin:0"></div>
                </v-row>
                <v-row class="ma-0" justify="center">
                  <v-col class="py-8 col-12 col-sm-10 col-md-8">
                    <v-img :src="images.empty"></v-img>
                  </v-col>
                </v-row>
                <h1 class="title-text2 warnning-text">目前非招生期間，系統暫停開放</h1>
                <h1 class="title-text3 gray">如有相關需求，請洽招生專線 (03)5961232</h1>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0" justify="center">
        <h4 class="mb-4 pt14" style="color:#FFF">Copyright©2025 東泰高級中學</h4>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
  components: {},
  mounted(){
    this.calculateWindows()
    window.onresize = () => {
      this.calculateWindows()
    }
  },
  data:()=>({
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/logo.png'),
      title: require('@/assets/image/title.png'),
      school: require('@/assets/image/school.png'),
      empty: require('@/assets/image/Empty.png'),
      icon_L1: require('@/assets/image/icon_L1.png'),
      icon_L2: require('@/assets/image/icon_L2.png'),
      icon_L3: require('@/assets/image/icon_L3.png'),
      icon_L4: require('@/assets/image/icon_L4.png'),
      icon_R1: require('@/assets/image/icon_R1.png'),
      icon_R2: require('@/assets/image/icon_R2.png'),
      icon_R3: require('@/assets/image/icon_R3.png'),
      icon_R4: require('@/assets/image/icon_R4.png'),
    },
  }),
  watch:{},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
  }
}
</script>

<style scoped>
.header-bar {
  position: relative;
  width: 100%;
  height: 210px;
}

.header-logo {
  position: absolute;
  top: 20px;
  left: 20px;
  max-width: 280px;
  width: 30%;
  min-width: 120px;
}

.header-title {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 760px;
  width: 50%;
  min-width: 120px;
}

.header-school {
  position: absolute;
  top: 0px;
  right: 0px;
  max-width: 360px;
  width: 28%;
  min-width: 120px;
}

.header-icon {
  position: absolute;
}

@media (max-width: 960px) {
  .header-logo {
    max-width: 340px;
    width: 50%;
  }
  .header-title {
    top: 60px;
    width: 160%;
  }
  .header-school {
    display: none
  }
}
</style>